<script setup>
import { reactive, computed } from 'vue';
import { getSpecialVisitColumn } from '@/billing/premiums/PremiumScript'
import { format$ } from '@/libraries/HelperFunctions';
import { getAppointmentsForDate } from '../firebase_files/appointment_functions';

const state = reactive({
    selectedCodes: [], // all codes we plan on billing
});
const props = defineProps(['newApt', 'timePeriodAppointments']);

const premiumCodes = computed(() => {
    console.log('bacta')
    return getSpecialVisitColumn(props.newApt)
})


function test(){
    premiumCodes.value.forEach((codeObject) => {
        debugger
        codeObject.validate({
            self: codeObject,
            timePeriodAppointments: props.timePeriodAppointments,
            newApt: props.newApt,
        })
    })
}
// const sortedCodes = computed(() => {
//     codeObjects = getSpecialVisitColumn(props.newApt);

// })


</script>
<template>
    <div v-if="props.newApt.specialVisit == 'No'">Fill out more questions.</div>
    <div v-else>
        <div v-for="(codeObject) in premiumCodes" :key="codeObject"
            :class="{ applicable: codeObject.applicable }" class="code-block" @click="test">
            <div class="info">
                <div class="code">{{codeObject.code }}</div>
                <div class="name">{{ codeObject.name }}</div>
                <div class="price">{{ format$(codeObject.price) }}</div>
                {{ codeObject.appliable }}
                {{ codeObject.reason }}
            </div>
            <div class="reason" v-if="codeObject.reasonNotApplicable"><i class="far fa-triangle-exclamation"></i> {{
                codeObject.reasonNotApplicable }}</div>
        </div>
    </div>
</template>
<styles lang="scss">
span.label {
    display: inline-block;
    vertical-align: top;
    padding-top: 4px;
    color: #673ab7;
    text-transform: uppercase;
}
</styles>